<template>
    <div class="layout">
        <Layout>
            <Header style="color:#fff"> 
                <div style="width:150px;padding-top:5px"><logo /></div>
            </Header>
            <Content style="padding:15px 50px">
                <Row>
                    <i-col :span="6">
                        <Form >
                               <FormItem prop="name">
                                <Input type="text" v-model="user.username" size="large" placeholder="请输入用户名">
                                    <Icon type="ios-person" slot="prepend"></Icon>
                                </Input>
                            </FormItem>
                            <FormItem prop="email">
                                <Input type="text" v-model="user.email" size="large" placeholder="请输入用户名">
                                    <Icon type="ios-person" slot="prepend"></Icon>
                                </Input>
                            </FormItem>
                            <FormItem prop="password">
                                <Input type="text" v-model="user.password" size="large" placeholder="请输入密码">
                                    <Icon type="ios-lock" slot="prepend"></Icon>
                                </Input>
                            </FormItem>
                            <FormItem>
                                <Upload :headers="headers" action="http://d.apicloud.com/mcm/api/file">
                                    <Button icon="ios-cloud-upload-outline">Upload files</Button>
                                </Upload>
                            </FormItem>
                            <FormItem>
                                <Button type="primary" size="large" long @click="add">添加</Button>
                                
                            </FormItem>
                            <FormItem>
                                <Button type="warning" size="large" long @click="vEmail">验证邮箱</Button>
                            </FormItem>
                            <FormItem>
                                <Button type="success" size="large" long @click="login">登录</Button>
                            </FormItem>
                            <FormItem>
                                <Button type="error" size="large" long @click="logoff">注销</Button>
                            </FormItem>
                        </Form>
                    </i-col>
                    
                </Row>
            </Content>
            <Footer>Footer</Footer>
        </Layout>
    </div>
</template>

<script>
import logo from '@/components/logo'
import {Post,Append_Header,headers} from '@/config/plugins/apicloud'
export default {
    components:{logo},
    data(){
        return {
            user:{
                email:'391140603@qq.com',password:'123456',username:'Rico'
            },
            auth:{
                token:'',
                id:''
            },
            headers:headers,
        }
    },
    methods:{
        add(){
            Post('/user',this.user).then(res=>{
                console.log(res.data);
            })
        },
        vEmail(){
            Post('/user/verifyEmail',this.user).then(res=>{
                console.log(res.data);
            })
        },
        login(){
            Post('/user/login',this.user).then(res=>{
                console.log(res.data);
                this.auth.token = res.data.id;
                this.auth.id = res.data.userId;
            })
        },
        logoff(){
            console.log(this.auth);
            Append_Header({key:'authorization',value:this.auth.token},'/user/logout').then(res=>{
                console.log(res.data);
            })
        },
       
    }
}
</script>

<style>

</style>